import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import gsap from 'gsap';
import { Application } from 'pixi.js';
import * as PIXI from 'pixi.js';
import { PixiPlugin } from "gsap/PixiPlugin";
import { GameStateService } from '../../../services/game-state/game-state.service';
import { CreateObjectsService } from '../../../services/create-objects/create-objects.service';
import { GameOverlayService } from '../../../services/game-overlay/game-overlay.service';
import { GameContainersService } from '../../../services/game-containers/game-containers.service';
import { SignialsService } from '../../../services/signals/signials.service';
import { HttpClientModule } from '@angular/common/http';
import { Path } from '../../../classes/path/path';
import { generatePathPoints, PATH_OFFSET, PATH_POINTS } from '../../../constants/parh-points';
import { catchError, concatMap, defer, EMPTY, first, fromEvent, iif, map, of, race, switchMap, take, tap, timer } from 'rxjs';
import { AudioService } from '../../../services/audio/audio.service';
import { PaymentService } from '../../ui/modals/payment/payment.service';
import { IGender } from '../../../interfaces/common-interfaces';
import { GameHeaderComponent } from '../../ui/hud/game-header/game-header.component';
import { GameUiService } from '../../../services/game-ui/game-ui.service';
import { GameState } from '../../../services/game-ui/game-state.enum';
import { LoadResoursesService } from '../../../services/load-resourses/load-resourses.service';
import { soundAssetsAdditional } from '../../../constants/sound';
import { IOSAudioService } from '../../../services/audio/audio-ios.service';
import { DayNightManager } from '../../../services/day-night/day-night.service';
import { LightMaskService, LightSource } from '../../../services/day-night/light-mask.service';
import { GameProgressBar } from '../../../classes/objects/progress-bar';
import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { SPINE_KEYS } from '../../../constants/textures';

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);
// Состояние системы
interface DayNightSystem {
  isNight: boolean;
  sprite: PIXI.Sprite;
  intervalId: number | null;
  darkenDuration: number;  // длительность затемнения
  lightenDuration: number; // длительность высветления
  targetTint: number;      // целевой цвет для ночи
}
@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrl: './game.component.scss',
  providers: [PaymentService],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameComponent implements AfterViewInit {
	@ViewChild('gameContainer', { static: true }) gameContainer!: ElementRef<HTMLDivElement>;
	app: Application;
	showBtn = false;

	dayNightManager: DayNightManager;

	private progressBar?: GameProgressBar;
	constructor(
		private cdr: ChangeDetectorRef,
		private createObjects: CreateObjectsService,
		private gameContainers: GameContainersService,
		private gameOverlay: GameOverlayService,
		private state: GameStateService,
		private signal: SignialsService,
		private audio: AudioService,
		private ui: GameUiService,
		private load: LoadResoursesService,
		private iosAudio: IOSAudioService,
		private lightMaskService: LightMaskService
	) {}

	ngAfterViewInit(): void {
		this.initGameFlow();
		document.addEventListener('visibilitychange', () => {
				if (!document.hidden) {
				fromEvent(window, 'click').pipe(take(1)).subscribe(() => {
					this.iosAudio.unlock();
				});
			}
		});

		window.addEventListener('pageshow', () => {
			fromEvent(window, 'click').pipe(take(1)).subscribe(() => {
				this.iosAudio.unlock();
			});
		});
	}

	private initGameFlow() {
		this.start();
		this.ensureGender$().pipe(
			concatMap((gender) => this.ensureQuestionResult$().pipe(map(() => gender))),
			tap((gender) => this.createPlayer(gender)),
			tap(() => this.ui.setState(GameState.Default)),
			switchMap(() => {
				this.audio.playSfx('Start_game');
				this.showOnboarding();
				setTimeout(() => {
					// this.signal.showResumeHint.next(true);

					// показываем как играть
					
				}, 2000);
				this.audio.playFon();

				if (localStorage.getItem('onboarding-start')) {
					return EMPTY;
				}
				 // что наступит первым — то и победит

				 return this.state.signal.hideResumeHint;
			}),
			tap(() => {
				// setTimeout(() => {if (!localStorage.getItem('onboarding-start')) this.showOnboarding()}, 30000);
				// const click$ = fromEvent(document, 'click').pipe(
				// 	first(), // берём только первый клик
				// 	tap(() => {console.log('2asdaaef');
				// 		localStorage.setItem('onboarding-start', 'shown');
				// 	})
				// ).subscribe();

				// const timeout$ = timer(3000).pipe(
				// 	tap(() => { console.log(123213); if (!localStorage.getItem('onboarding-start')) this.showOnboarding()})
				// );

				// return race(timeout$);
			})
		).subscribe(() => {});
	}

	private showOnboarding() {
		if (localStorage.getItem('onboarding-start')) return;
		localStorage.setItem('onboarding-start', 'shown');
		this.state.signal.modalShow.next('onboarding-start');
	}

	private ensureGender$() {
		return iif(
			() => !!localStorage.getItem('gender'),
			of(localStorage.getItem('gender') as IGender),
			defer(() => {
				this.state.signal.modalShow.next('select-gender');
				return this.state.signal.modalClosed.pipe(
					take(1),
					map(() => {
						const gender = localStorage.getItem('gender') as IGender | null;
						if (!gender) throw new Error('Пол не выбран');
						this.state.gender = gender;
						return gender;
					})
				);
			})
		);
	}
	loadSounds() {
		// this.load.loadGameSounds(soundAssetsAdditional).then();
	}

	private ensureQuestionResult$() {
		return iif(
			() => !!this.state.getGameStatus('questionResultStart'),
			of(true),
			defer(() => {
				this.state.signal.modalShow.next('question');
				return this.state.signal.modalClosed.pipe(
					take(1),
					tap(() => {
						const res = localStorage.getItem('questionResult');
						if (!res) {
							throw new Error('Вопрос не решён');
						} else {
					    this.state.changeGameStatus('questionResultStart', res);
						}
					}),
					map(() => true)
				);
			})
		);
	}

	
	start() {
		this.createApp();

		this.createInnerContainers();
		this.createPath();

		this.generateMap();

		setTimeout(() => {
			this.signal.gameReady.next(true);
			this.showBtn = true;
			this.cdr.detectChanges();
		}, 150);
		
	}

	createApp() {
		this.app = new Application();
    
    // 2. Инициализируем асинхронно с передачей всех настроек в init()
    this.app.init({
        background: 0x000000,          // цвет фона
        resizeTo: this.gameContainer.nativeElement,  // авто-ресайз под контейнер
        resolution: window.devicePixelRatio || 1,
        antialias: true,               // ✅ в v8 параметр есть [citation:9]
        autoDensity: true,
    }).then(() => {
			// 3. Добавляем canvas в DOM — используем app.canvas (не app.view!)
			this.gameContainer.nativeElement.appendChild(this.app.canvas);
			
			// 4. Настройка stage — почти без изменений
			this.app.stage.sortableChildren = true;
			this.app.stage.eventMode = 'static';  // eventMode работает так же [citation:2]
			
			this.state.app = this.app;

			(window as any).__PIXI_APP__ = this.app;
			(window as any).__PIXI_STAGE__ = this.app.stage;
			(window as any).__PIXI_RENDERER__ = this.app.renderer;

			const canvas = this.app.view;
			canvas.addEventListener?.('touchmove', function(e) {
				e.preventDefault();
			}, { passive: false });
		});
	}

	createInnerContainers() {
		const camera = this.gameContainers.createCamera();
		this.app.stage.addChild(camera);

		const overlay = this.gameOverlay.createOverlay();
		this.app.stage.addChild(overlay);

		const field = this.gameContainers.createField();
		camera.addChild(field);
	}

	createPath() {
		generatePathPoints(PATH_POINTS, PATH_OFFSET);
	}

	generateMap() {
		const [objects, nightLightObjects, otherLightObject] = this.createObjects.getSprites();
		const spines = this.createObjects.getSpines() as any;
		// console.log(objects, spines);
		const container = new PIXI.Container();
		container.x = 0;
		container.y = 0;
		container.zIndex = 999.1;
		container.addChild(...nightLightObjects);

		const container2 = new PIXI.Container();
		container2.x = 0;
		container2.y = 0;
		container2.addChild(...objects, ...spines);
		this.gameContainers.mainField = container2;

		const container3 = new PIXI.Container();
		container3.x = 0;
		container3.y = 0;
		container3.zIndex = 999;
		container3.addChild(...otherLightObject);

	 	// this.dayNightManager = new DayNightManager(
    //   [container2],
		// 	[container],
		// 	0x444444,
    //   10,
    //   10
    // );

    // // this.dayNightManager.startCycle(0.5);
		// this.dayNightManager.setNight();

		// const lights: LightSource[] = [
    //   {
    //     x: 400,
    //     y: 300,
    //     type: 'circle',
    //     radius: 120,
    //     blur: 16,
    //     intensity: 1.0
    //   },
    //   {
    //     x: 800,
    //     y: 500,
    //     type: 'ellipse',
    //     width: 150,
    //     height: 80,
    //     blur: 20,
    //     intensity: 0.7
    //   },
    //   {
    //     x: 200,
    //     y: 600,
    //     type: 'rect',
    //     width: 100,
    //     height: 60,
    //     blur: 8,
    //     intensity: 0.5
    //   }
    // ];

		// const lightSystem = this.lightMaskService.createLightMask({
    //   width: 1280,
    //   height: 720,
    //   darkAlpha: 0.7,  // начальный уровень темноты (день/ночь)
    //   backgroundColor: 0x000000,
    //   lights: lights
    // });

		this.gameContainers.field.addChild(container2);
		// this.gameContainers.field.addChild(container2, container, container3);
		this.state.containers.resized();
	}

	createPlayer(gender: IGender) {
		const player = this.createObjects.createPlayer(gender ?? 'male') as any;
		this.state.gender = gender ?? 'male';

		this.state.path = new Path(this.state);
		if (!player) return;
		this.gameContainers.mainField.addChild(player);
		// console.log('INIT PLAYER POSITION');
		this.state.player.initPosition();

	}
}
